import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'filterByTag',
  standalone: false,
})
export class FilterByTagPipe implements PipeTransform {
  transform(items: any[], searchTerm: string): any[] {
    if (!items) return []
    if (!searchTerm) return items

    searchTerm = searchTerm.toLowerCase()

    return items.filter((item) => {
      const nameMatches = item.name.toLowerCase().includes(searchTerm)

      const tagMatches = item.tags.some((tag: any) =>
        [...searchTerm].every((letter) => tag.toLowerCase().includes(letter)),
      )

      return nameMatches || tagMatches
    })
  }
}
